import { Component, OnInit, inject } from '@angular/core';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { MeService } from '../../../core/services/me.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { User } from '../../../core/models/user.model';
import { FormsModule } from '@angular/forms';
import { PhoneNumberValidatorDirective } from '../../directives/phone-validator.directive';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-confirm-mfa-phone-modal',
    templateUrl: './confirm-mfa-phone-modal.component.html',
    styleUrls: ['./confirm-mfa-phone-modal.component.scss'],
    imports: [FormsModule, PhoneNumberValidatorDirective, NgClass]
})
export class ConfirmMfaPhoneModalComponent implements OnInit {
  activeModal = inject(NgbActiveModal);
  meService = inject(MeService);
  authService = inject(AuthenticationService);

  serverError = false;
  formModel: { phoneNumber: string } = { phoneNumber: null };

  ngOnInit() {}

  onSubmit() {
    this.serverError = false;

    this.meService.confirmMfaPhoneNumber(this.formModel.phoneNumber).subscribe(
      (user: User) => {
        this.authService.updateCurrentUser(user);
        this.activeModal.close();
      },
      err => {
        console.log(err);
        this.serverError = true;
      }
    );
  }
}
